export default __webpack_public_path__ + "static/media/featured_area_burlington.9f3a0d6e.webp";